import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

export default class NoteBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button onClick={this.handleShow} className="edit-order-btn">
                    Note
                </button>

                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.type === 'reason_inactive' ? 'Reason for Inactive' : 'Note'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.type === 'reason_inactive' ? this.props.data.reason_inactive : this.props.data.note}
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
